import React from "react";

const Alert = ({ msg }) => {
  return <div className="alert">{msg}</div>;
};

export default Alert;
